export function pattern_triangle({compId,shapeHeight,animationSpeed,flipAnimation}) {
  let flipA = 8;
  if(flipAnimation)flipA = 4;
  return `
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" style="transform: translate(${-shapeHeight*flipA}px,0)" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
    <path d="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z">
      <animate attributeType="xml" attributeName="d"
      values="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z;
      M 0 240 L 960 60 L 1920 240 L 1920 240 L 0 240 L 0 240 Z;
      M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path opacity=".5" d="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="660 120;540 120;660 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path opacity=".5" d="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="-660 120;-540 120;-660 120"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path opacity=".5" d="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z">
      <animate attributeType="xml" attributeName="d"
      values="M 0 0 L 960 180 L 1920 0 L 1920 240 L 0 240 L 0 0 Z;
        M0,0 L960,240 L1920,0 L1920,240 L0,240 L0,0Z;
        M 0 0 L 960 180 L 1920 0 L 1920 240 L 0 240 L 0 0 Z"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite" />
    </path>
    <path opacity=".5" d="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="300 0;420 0;300 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
    <path opacity=".5" d="M0,240 L960,0 L1920,240 L1920,240 L0,240 L0,240Z">
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="-300 0;-420 0;-300 0"
      keyTimes="0;0.5;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.5 * animationSpeed}s"
      dur="${6 * animationSpeed}s" repeatCount="indefinite"/>
    </path>
  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}